import { render, staticRenderFns } from "./gRNAResult2.vue?vue&type=template&id=6924fb4b&scoped=true"
import script from "./gRNAResult2.vue?vue&type=script&lang=js"
export * from "./gRNAResult2.vue?vue&type=script&lang=js"
import style0 from "./gRNAResult2.vue?vue&type=style&index=0&id=6924fb4b&prod&lang=less&scoped=true"
import style1 from "./gRNAResult2.vue?vue&type=style&index=1&id=6924fb4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924fb4b",
  null
  
)

export default component.exports